/*
  Native cart offers: free gift over a spend threshold, a bonus offer and recommendations.
  Config comes from snippets/cart-offers.liquid (Theme settings > Cart).

  Free gift: the gift line is added with the hidden property _free_gift so it never merges
  with socks a customer buys themselves. It is removed again when the cart drops below the
  threshold. If the customer removes it while qualifying, it stays removed for the session
  and a "re-add" link is shown instead.
*/
(function() {
  var configEl = document.getElementById('CartOffersConfig');
  if (!configEl) return;

  var config = JSON.parse(configEl.textContent);
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var GIFT_PROPERTY = '_free_gift';
  var ADDED_KEY = 'cartOffers:giftAdded';
  var DECLINED_KEY = 'cartOffers:giftDeclined';
  var syncing = false;
  var recommendationCache = {};

  function storage(method, key, value) {
    try {
      return window.sessionStorage[method](key, value);
    } catch (e) {
      return null;
    }
  }

  function money(cents) {
    if (window.theme && theme.Currency) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, function(c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function request(path, body) {
    var options = body
      ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }
      : { headers: { Accept: 'application/json' } };
    return fetch(root + path, options).then(function(response) {
      if (!response.ok) throw response;
      return response.json();
    });
  }

  function isCartPage() {
    return !!document.querySelector('[data-cart-offers]');
  }

  // Ask the theme to redraw the cart (drawer) or reload the cart page.
  function refreshCart() {
    if (isCartPage()) {
      window.location.reload();
    } else {
      document.dispatchEvent(new CustomEvent('cart:build'));
    }
  }

  function giftLines(cart) {
    return cart.items.filter(function(item) {
      return item.properties && item.properties[GIFT_PROPERTY];
    });
  }

  function qualifyingTotal(cart) {
    return giftLines(cart).reduce(function(total, item) {
      return total - item.final_line_price;
    }, cart.total_price);
  }

  // Returns a promise resolving to true when the cart was changed.
  function syncGift(cart) {
    var gift = config.gift;
    if (!gift || syncing) return Promise.resolve(false);

    var lines = giftLines(cart);
    var qualifies = qualifyingTotal(cart) >= gift.threshold;
    var updates = {};

    if (!qualifies) {
      storage('removeItem', ADDED_KEY);
      storage('removeItem', DECLINED_KEY);
      if (!lines.length) return Promise.resolve(false);
      lines.forEach(function(line) { updates[line.key] = 0; });
      return change({ updates: updates });
    }

    if (!lines.length) {
      if (storage('getItem', ADDED_KEY)) storage('setItem', DECLINED_KEY, '1');
      if (storage('getItem', DECLINED_KEY)) return Promise.resolve(false);
      return addGift();
    }

    if (lines.length > 1 || lines[0].quantity > 1) {
      lines.forEach(function(line, index) { updates[line.key] = index === 0 ? 1 : 0; });
      return change({ updates: updates });
    }

    return Promise.resolve(false);
  }

  function addGift() {
    var properties = {};
    properties[GIFT_PROPERTY] = 'true';
    return change({ items: [{ id: config.gift.variantId, quantity: 1, properties: properties }] }, 'cart/add.js')
      .then(function(changed) {
        if (changed) {
          storage('setItem', ADDED_KEY, '1');
          storage('removeItem', DECLINED_KEY);
        }
        return changed;
      });
  }

  function change(body, path) {
    syncing = true;
    return request(path || 'cart/update.js', body)
      .then(function() { return true; })
      .catch(function() { return false; })
      .then(function(changed) {
        syncing = false;
        return changed;
      });
  }

  function giftMessage(cart) {
    var gift = config.gift;
    if (!gift) return '';

    var total = qualifyingTotal(cart);
    var title = escapeHtml(gift.title);
    var text;
    var percent = Math.min(100, Math.round((total / gift.threshold) * 100));

    if (total < gift.threshold) {
      text = config.strings.giftProgress
        .replace('[amount]', money(gift.threshold - total))
        .replace('[gift]', title);
    } else if (giftLines(cart).length) {
      text = config.strings.giftUnlocked.replace('[gift]', title);
    } else {
      text = config.strings.giftDeclined.replace('[gift]', title) +
        ' <button type="button" class="cart-offers__link" data-cart-offers-readd>' +
        config.strings.giftReAdd + '</button>';
    }

    return '<div class="cart-offers__gift">' +
      '<p class="cart-offers__gift-text">' + text + '</p>' +
      '<div class="cart-offers__bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + percent + '">' +
      '<span style="width:' + percent + '%"></span></div></div>';
  }

  function offerCard(offer) {
    var choices = '';
    if (offer.choices && offer.choices.length > 1) {
      choices = '<label class="visually-hidden" for="CartOffer-' + offer.key + '">' + escapeHtml(offer.choiceLabel) + '</label>' +
        '<select id="CartOffer-' + offer.key + '" class="cart-offers__select" data-cart-offer-choice>' +
        '<option value="">' + escapeHtml(offer.choiceLabel || config.strings.choose) + '</option>' +
        offer.choices.map(function(choice) {
          return '<option value="' + escapeHtml(choice.value) + '">' + escapeHtml(choice.label) + '</option>';
        }).join('') + '</select>';
    } else if (offer.choices && offer.choices.length === 1 && offer.choiceLabel) {
      // Only one size left: say which one so it isn't added blind.
      choices = '<span class="cart-offers__only">' + escapeHtml(offer.choiceLabel) + ': ' + escapeHtml(offer.choices[0].label) + '</span>';
    }

    var compare = offer.compareAtPrice > offer.price
      ? ' <s class="cart-offers__compare">' + money(offer.compareAtPrice) + '</s>'
      : '';

    return '<div class="cart-offers__card" data-cart-offer=\'' + escapeHtml(JSON.stringify(offer.add)) + '\'' +
      ' data-cart-offer-choice-type="' + (offer.choiceType || '') + '"' +
      ' data-cart-offer-choice-name="' + escapeHtml(offer.choiceLabel || '') + '">' +
      (offer.image ? '<a href="' + escapeHtml(offer.url) + '" class="cart-offers__image"><img src="' + escapeHtml(offer.image) + '" alt="" loading="lazy" width="80" height="80"></a>' : '') +
      '<div class="cart-offers__details">' +
      '<a href="' + escapeHtml(offer.url) + '" class="cart-offers__title">' + escapeHtml(offer.title) + '</a>' +
      '<div class="cart-offers__price">' + money(offer.price) + compare + '</div>' +
      '<div class="cart-offers__actions">' + choices +
      '<button type="button" class="btn btn--small cart-offers__add" data-cart-offer-add>' + escapeHtml(config.strings.add) + '</button>' +
      '</div></div></div>';
  }

  function bonusOffer(cart) {
    var bonus = config.bonus;
    if (!bonus) return null;
    var inCart = cart.items.some(function(item) { return item.product_id === bonus.productId; });
    if (inCart) return null;

    return {
      key: 'bonus',
      title: bonus.title,
      url: bonus.url,
      image: bonus.image,
      price: bonus.price,
      compareAtPrice: bonus.compareAtPrice,
      choiceLabel: bonus.optionLabel,
      choiceType: 'property',
      choices: bonus.options.split(/\r?\n/).map(function(option) { return option.trim(); }).filter(Boolean)
        .map(function(option) { return { value: option, label: option }; }),
      add: { id: bonus.variantId }
    };
  }

  function loadRecommendations(cart) {
    var settings = config.recommendations;
    var anchor = cart.items.filter(function(item) {
      return !(item.properties && item.properties[GIFT_PROPERTY]);
    })[0];
    if (!settings || !anchor) return Promise.resolve([]);

    var id = anchor.product_id;
    if (!recommendationCache[id]) {
      var url = 'recommendations/products.json?product_id=' + id + '&limit=8&intent=';
      recommendationCache[id] = request(url + 'complementary')
        .then(function(data) { return data.products.length ? data : request(url + 'related'); })
        .then(function(data) { return data.products; })
        .catch(function() { return []; });
    }

    return recommendationCache[id].then(function(products) {
      var exclude = cart.items.map(function(item) { return item.product_id; });
      if (config.gift) exclude.push(config.gift.productId);
      if (config.bonus) exclude.push(config.bonus.productId);

      return products.filter(function(product) {
        return product.available && exclude.indexOf(product.id) === -1;
      }).slice(0, settings.count).map(function(product) {
        var variants = product.variants.filter(function(variant) { return variant.available; });
        return {
          key: 'rec-' + product.id,
          title: product.title,
          url: product.url,
          image: product.featured_image ? product.featured_image.replace(/(\.[^.?]*)(\?|$)/, '_160x$1$2') : '',
          price: variants[0].price,
          compareAtPrice: variants[0].compare_at_price || 0,
          choiceLabel: product.options[0] && product.options[0].name !== 'Title' ? product.options[0].name : '',
          choiceType: 'variant',
          choices: variants.map(function(variant) { return { value: variant.id, label: variant.title }; }),
          add: { id: variants[0].id }
        };
      });
    });
  }

  function render(cart) {
    var target = isCartPage()
      ? document.querySelector('[data-cart-offers]')
      : document.querySelector('#CartContainer .drawer__scrollable');
    if (!target || !cart.item_count) return;

    var container = target.querySelector('.cart-offers');
    if (!container) {
      container = document.createElement('div');
      container.className = 'cart-offers';
      var note = target.querySelector('.cart-notes');
      var before = note ? note.closest('.appear-animation') || note : null;
      target.insertBefore(container, before);
    }

    loadRecommendations(cart).then(function(recommendations) {
      var bonus = bonusOffer(cart);
      var html = giftMessage(cart);
      if (bonus) {
        html += '<div class="cart-offers__group"><p class="cart-offers__heading">' + escapeHtml(config.bonus.heading) + '</p>' + offerCard(bonus) + '</div>';
      }
      if (recommendations.length) {
        html += '<div class="cart-offers__group"><p class="cart-offers__heading">' + escapeHtml(config.recommendations.heading) + '</p>' +
          recommendations.map(offerCard).join('') + '</div>';
      }
      container.innerHTML = html;
    });
  }

  function handleCart(cart) {
    syncGift(cart).then(function(changed) {
      if (changed) {
        refreshCart();
      } else {
        render(cart);
      }
    });
  }

  document.addEventListener('click', function(evt) {
    var readd = evt.target.closest('[data-cart-offers-readd]');
    if (readd) {
      readd.disabled = true;
      addGift().then(refreshCart);
      return;
    }

    var button = evt.target.closest('[data-cart-offer-add]');
    if (!button) return;

    var card = button.closest('[data-cart-offer]');
    var item = JSON.parse(card.getAttribute('data-cart-offer'));
    var select = card.querySelector('[data-cart-offer-choice]');
    item.quantity = 1;

    if (select) {
      if (!select.value) {
        select.focus();
        select.classList.add('is-invalid');
        return;
      }
      if (card.getAttribute('data-cart-offer-choice-type') === 'variant') {
        item.id = Number(select.value);
      } else {
        item.properties = {};
        item.properties[card.getAttribute('data-cart-offer-choice-name') || 'Option'] = select.value;
      }
    }

    button.disabled = true;
    request('cart/add.js', { items: [item] }).then(refreshCart, function() {
      button.disabled = false;
    });
  });

  // The drawer fires cart:updated after every rebuild (page load, add to cart, quantity change).
  // Its cart object has had hidden "_" properties stripped, so read a fresh copy.
  document.addEventListener('cart:updated', function() {
    request('cart.js').then(handleCart);
  });

  if (isCartPage()) {
    request('cart.js').then(handleCart);
  }
})();
